/**
 * Polyfill stable language features. These imports will be optimized by `@babel/preset-env`.
 *
 * See: https://github.com/zloirock/core-js#babel
 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
// Polyfills for older browser compatibility
import 'whatwg-fetch';

// Ensure global objects exist for Adobe scripts
if (typeof global === 'undefined') {
  (window as any).global = window;
}
